var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _ellipse2, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembershipEmptyStateUnderConstructionLight = function SvgMembershipEmptyStateUnderConstructionLight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 200 200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    d: "M26 48a2 2 0 0 1 2-2h144a2 2 0 0 1 2 2v14H26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 62h148v92a2 2 0 0 1-2 2H28a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.116,
    height: 5.136,
    fill: "#E37570",
    rx: 2.558,
    transform: "matrix(1 0 0 -1 31.116 56.425)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.116,
    height: 5.136,
    fill: "#EFBA0F",
    rx: 2.558,
    transform: "matrix(1 0 0 -1 40.069 56.425)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.116,
    height: 5.136,
    fill: "#4ACC82",
    rx: 2.558,
    transform: "matrix(1 0 0 -1 49.022 56.425)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 80.546,
    height: 62.773,
    x: 55.5,
    y: 78.727,
    stroke: "#E6E9ED",
    strokeDasharray: "6 6",
    strokeLinejoin: "round",
    strokeMiterlimit: 16,
    rx: 4.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 79.614,
    height: 61.636,
    fill: "#F4F7F8",
    rx: 2,
    transform: "matrix(-1 0 0 1 141.932 73)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CED4",
    fillRule: "evenodd",
    d: "M95.766 127.078c-.584-4.411-3.958-6.498-5.435-7.315-1.987-1.099-4.747-1.761-8.672-1.761s-6.685.662-8.672 1.761c-.574.317-1.434.9-2.305 1.725v3.59a2 2 0 0 0 2 2zM81.66 115.435c-4.192 0-7.591-3.448-7.591-7.701s3.399-7.702 7.591-7.702 7.592 3.448 7.592 7.702-3.399 7.701-7.592 7.701M133.409 120.859a14 14 0 0 0-1.944-1.252c-2.018-1.09-4.822-1.747-8.809-1.747s-6.792.657-8.81 1.747c-1.506.814-4.954 3.388-5.528 7.309H132.2a2 2 0 0 0 1.209-1.838zm-10.753-5.546c-4.259 0-7.712-3.421-7.712-7.64 0-4.22 3.453-7.641 7.712-7.641s7.712 3.421 7.712 7.641c0 4.219-3.453 7.64-7.712 7.64",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9EA4AC",
    d: "M81.435 126.916h39.429c-.789-6.176-5.53-9.092-7.602-10.232-2.775-1.527-6.63-2.446-12.113-2.446s-9.338.919-12.113 2.446c-2.071 1.14-6.812 4.743-7.6 10.232M90.545 99.976c0 5.907 4.748 10.696 10.605 10.696 5.856 0 10.604-4.789 10.604-10.696 0-5.908-4.748-10.697-10.604-10.697-5.857 0-10.605 4.79-10.605 10.697"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m134.577 185.133 13.543-7.472a1.182 1.182 0 0 0 0-2.069l-15.255-8.416-15.254 8.416a1.181 1.181 0 0 0 0 2.069l13.542 7.472a3.54 3.54 0 0 0 3.424 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M135.228 154.181h-4.725l-6.455 20.244s-1.176 5.746 8.817 5.746 8.818-5.746 8.818-5.746z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m140.359 170.275-1.699-5.331c-2.956 3.346-9.172 2.804-11.59.003l-1.699 5.328c.421 1.227 1.981 3.989 7.494 3.989 5.514 0 7.074-2.762 7.494-3.989M128.784 159.571c.778.917 2.041 1.698 4.081 1.698s3.303-.781 4.081-1.698l-1.718-5.39h-1.453a4.6 4.6 0 0 1-1.705 0h-1.567z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.363,
    cy: 1.181,
    fill: "#FE734F",
    rx: 2.363,
    ry: 1.181,
    transform: "matrix(-1 0 0 1 135.228 153)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m23.153 166.133-13.542-7.472a1.182 1.182 0 0 1 0-2.069l15.254-8.416 15.255 8.416c.814.45.814 1.62 0 2.069l-13.543 7.472a3.54 3.54 0 0 1-3.424 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.503 135.181h4.725l6.455 20.244s1.175 5.746-8.818 5.746-8.817-5.746-8.817-5.746z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE734F",
    d: "m17.371 151.275 1.7-5.331c2.956 3.346 9.171 2.804 11.59.003l1.698 5.328c-.42 1.227-1.98 3.989-7.494 3.989s-7.073-2.762-7.494-3.989M28.946 140.571c-.778.917-2.04 1.698-4.08 1.698s-3.303-.781-4.082-1.698l1.719-5.39h1.453a4.6 4.6 0 0 0 1.704 0h1.568z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.865,
    cy: 135.181,
    fill: "#FE734F",
    rx: 2.363,
    ry: 1.181
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C9CED4",
    strokeLinecap: "round",
    d: "M14.5 72v3.235M20 77.5h-3.235M14.5 79.765V83M12.235 77.5H9M186.5 105v3.235M192 110.5h-3.235M186.5 112.765V116M184.235 110.5H181"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembershipEmptyStateUnderConstructionLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "membership-empty-state-under-construction-light.svg";